import cx from 'classnames'
import * as React from 'react'
import styles from './Icon.m.sass'

export interface IconProps extends React.SVGAttributes<SVGElement> {
  name: IconName
  auto?: boolean
  color?: string
  rotate?: number
  size?: number
}

export default React.forwardRef(function Icon(
  { name, size, className, color, auto, style, rotate, ...rest }: IconProps,
  ref,
) {
  const IconClass = iconsMap.get(name)
  return (
    <IconClass
      ref={ref}
      style={{
        color,
        transform: rotate ? `rotate(${rotate}deg)` : undefined,
        ...(size ? { fontSize: size } : undefined),
        ...style,
      }}
      className={cx(styles.icon, !auto && styles.defaultSize, className)}
      {...rest}
    />
  )
})

// Don't mind this, it's generated by a tool.
// Icon map start (DO NOT EDIT)
// prettier-ignore
const iconsMap = new Map<string, any>([
  ['add-people', require('assets/icons/add-people.i.svg').default],
  ['add', require('assets/icons/add.i.svg').default],
  ['alert-avatar', require('assets/icons/alert-avatar.i.svg').default],
  ['alert-blue', require('assets/icons/alert-blue.i.svg').default],
  ['alert', require('assets/icons/alert.i.svg').default],
  ['amex', require('assets/icons/amex.i.svg').default],
  ['analytics', require('assets/icons/analytics.i.svg').default],
  ['arrow-hover', require('assets/icons/arrow-hover.i.svg').default],
  ['arrow', require('assets/icons/arrow.i.svg').default],
  ['back', require('assets/icons/back.i.svg').default],
  ['benefits', require('assets/icons/benefits.i.svg').default],
  ['call-end-call', require('assets/icons/call-end-call.i.svg').default],
  ['call-fullscreen-off', require('assets/icons/call-fullscreen-off.i.svg').default],
  ['call-fullscreen-on', require('assets/icons/call-fullscreen-on.i.svg').default],
  ['call-mic-off', require('assets/icons/call-mic-off.i.svg').default],
  ['call-mic-on', require('assets/icons/call-mic-on.i.svg').default],
  ['call-return', require('assets/icons/call-return.i.svg').default],
  ['call-screenshare-off', require('assets/icons/call-screenshare-off.i.svg').default],
  ['call-screenshare-on', require('assets/icons/call-screenshare-on.i.svg').default],
  ['call-speakers', require('assets/icons/call-speakers.i.svg').default],
  ['call-video-off', require('assets/icons/call-video-off.i.svg').default],
  ['call-video-on', require('assets/icons/call-video-on.i.svg').default],
  ['camera-off', require('assets/icons/camera-off.i.svg').default],
  ['camera', require('assets/icons/camera.i.svg').default],
  ['card', require('assets/icons/card.i.svg').default],
  ['change-start-date', require('assets/icons/change-start-date.i.svg').default],
  ['chart-arrow-up', require('assets/icons/chart-arrow-up.i.svg').default],
  ['chat-attachment', require('assets/icons/chat-attachment.i.svg').default],
  ['chat-bold', require('assets/icons/chat-bold.i.svg').default],
  ['chat-channels', require('assets/icons/chat-channels.i.svg').default],
  ['chat-code', require('assets/icons/chat-code.i.svg').default],
  ['chat-cursive', require('assets/icons/chat-cursive.i.svg').default],
  ['chat-delete', require('assets/icons/chat-delete.i.svg').default],
  ['chat-edit', require('assets/icons/chat-edit.i.svg').default],
  ['chat-emoji', require('assets/icons/chat-emoji.i.svg').default],
  ['chat-formatting', require('assets/icons/chat-formatting.i.svg').default],
  ['chat-h1', require('assets/icons/chat-h1.i.svg').default],
  ['chat-h2', require('assets/icons/chat-h2.i.svg').default],
  ['chat-image', require('assets/icons/chat-image.i.svg').default],
  ['chat-link', require('assets/icons/chat-link.i.svg').default],
  ['chat-list-bullet', require('assets/icons/chat-list-bullet.i.svg').default],
  ['chat-list-ordered', require('assets/icons/chat-list-ordered.i.svg').default],
  ['chat-mention', require('assets/icons/chat-mention.i.svg').default],
  ['chat-note', require('assets/icons/chat-note.i.svg').default],
  ['chat-plus', require('assets/icons/chat-plus.i.svg').default],
  ['chat-prompt', require('assets/icons/chat-prompt.i.svg').default],
  ['chat-reaction', require('assets/icons/chat-reaction.i.svg').default],
  ['chat-strikethrough', require('assets/icons/chat-strikethrough.i.svg').default],
  ['checkbox-blank', require('assets/icons/checkbox-blank.i.svg').default],
  ['checkbox-indeterminate', require('assets/icons/checkbox-indeterminate.i.svg').default],
  ['checkbox-invert', require('assets/icons/checkbox-invert.i.svg').default],
  ['checkbox', require('assets/icons/checkbox.i.svg').default],
  ['checkered-pattern', require('assets/icons/checkered-pattern.i.svg').default],
  ['checkmark', require('assets/icons/checkmark.i.svg').default],
  ['circle', require('assets/icons/circle.i.svg').default],
  ['clock', require('assets/icons/clock.i.svg').default],
  ['close', require('assets/icons/close.i.svg').default],
  ['collaborators', require('assets/icons/collaborators.i.svg').default],
  ['collect-payment', require('assets/icons/collect-payment.i.svg').default],
  ['colorpicker', require('assets/icons/colorpicker.i.svg').default],
  ['complete-job', require('assets/icons/complete-job.i.svg').default],
  ['computer', require('assets/icons/computer.i.svg').default],
  ['copy', require('assets/icons/copy.i.svg').default],
  ['coupons', require('assets/icons/coupons.i.svg').default],
  ['dashboard', require('assets/icons/dashboard.i.svg').default],
  ['date-claimed', require('assets/icons/date-claimed.i.svg').default],
  ['date-completed', require('assets/icons/date-completed.i.svg').default],
  ['date-created', require('assets/icons/date-created.i.svg').default],
  ['date-deadline', require('assets/icons/date-deadline.i.svg').default],
  ['date-start', require('assets/icons/date-start.i.svg').default],
  ['date-submitted', require('assets/icons/date-submitted.i.svg').default],
  ['date-transacted', require('assets/icons/date-transacted.i.svg').default],
  ['date-transferred', require('assets/icons/date-transferred.i.svg').default],
  ['declined', require('assets/icons/declined.i.svg').default],
  ['default-payment', require('assets/icons/default-payment.i.svg').default],
  ['delete', require('assets/icons/delete.i.svg').default],
  ['density-comfortable', require('assets/icons/density-comfortable.i.svg').default],
  ['density-compact', require('assets/icons/density-compact.i.svg').default],
  ['density-default', require('assets/icons/density-default.i.svg').default],
  ['discover', require('assets/icons/discover.i.svg').default],
  ['documents', require('assets/icons/documents.i.svg').default],
  ['download-pbfx', require('assets/icons/download-pbfx.i.svg').default],
  ['download', require('assets/icons/download.i.svg').default],
  ['drag', require('assets/icons/drag.i.svg').default],
  ['dropdown', require('assets/icons/dropdown.i.svg').default],
  ['edit-outlined', require('assets/icons/edit-outlined.i.svg').default],
  ['edit-roles', require('assets/icons/edit-roles.i.svg').default],
  ['edit-skills', require('assets/icons/edit-skills.i.svg').default],
  ['edit', require('assets/icons/edit.i.svg').default],
  ['emojis', require('assets/icons/emojis.i.svg').default],
  ['filter', require('assets/icons/filter.i.svg').default],
  ['flags', require('assets/icons/flags.i.svg').default],
  ['forfeit-job', require('assets/icons/forfeit-job.i.svg').default],
  ['gif', require('assets/icons/gif.i.svg').default],
  ['googledrive', require('assets/icons/googledrive.i.svg').default],
  ['hashtag', require('assets/icons/hashtag.i.svg').default],
  ['heart', require('assets/icons/heart.i.svg').default],
  ['hide', require('assets/icons/hide.i.svg').default],
  ['hover-arrow-highlight', require('assets/icons/hover-arrow-highlight.i.svg').default],
  ['hover-arrow', require('assets/icons/hover-arrow.i.svg').default],
  ['hover-menu-highlight', require('assets/icons/hover-menu-highlight.i.svg').default],
  ['hover-menu', require('assets/icons/hover-menu.i.svg').default],
  ['info-blue', require('assets/icons/info-blue.i.svg').default],
  ['info', require('assets/icons/info.i.svg').default],
  ['invoices', require('assets/icons/invoices.i.svg').default],
  ['job-updates', require('assets/icons/job-updates.i.svg').default],
  ['jobs', require('assets/icons/jobs.i.svg').default],
  ['kanban-view', require('assets/icons/kanban-view.i.svg').default],
  ['legend-builder-breaker', require('assets/icons/legend-builder-breaker.i.svg').default],
  ['legend-builder-choice', require('assets/icons/legend-builder-choice.i.svg').default],
  ['legend-builder-datetime', require('assets/icons/legend-builder-datetime.i.svg').default],
  ['legend-builder-document-upload', require('assets/icons/legend-builder-document-upload.i.svg').default],
  ['legend-builder-effect', require('assets/icons/legend-builder-effect.i.svg').default],
  ['legend-builder-milestones', require('assets/icons/legend-builder-milestones.i.svg').default],
  ['legend-builder-numeric', require('assets/icons/legend-builder-numeric.i.svg').default],
  ['legend-builder-path', require('assets/icons/legend-builder-path.i.svg').default],
  ['legend-builder-task', require('assets/icons/legend-builder-task.i.svg').default],
  ['legend-builder-text', require('assets/icons/legend-builder-text.i.svg').default],
  ['legend-builder-yes-no', require('assets/icons/legend-builder-yes-no.i.svg').default],
  ['legends', require('assets/icons/legends.i.svg').default],
  ['link', require('assets/icons/link.i.svg').default],
  ['list-view', require('assets/icons/list-view.i.svg').default],
  ['loader-arrows', require('assets/icons/loader-arrows.i.svg').default],
  ['loader', require('assets/icons/loader.i.svg').default],
  ['lock', require('assets/icons/lock.i.svg').default],
  ['make-corrections', require('assets/icons/make-corrections.i.svg').default],
  ['mastercard', require('assets/icons/mastercard.i.svg').default],
  ['menu', require('assets/icons/menu.i.svg').default],
  ['message-bank', require('assets/icons/message-bank.i.svg').default],
  ['mic', require('assets/icons/mic.i.svg').default],
  ['more', require('assets/icons/more.i.svg').default],
  ['new-amendment', require('assets/icons/new-amendment.i.svg').default],
  ['notifications-thick-muted', require('assets/icons/notifications-thick-muted.i.svg').default],
  ['notifications-thick-muted2', require('assets/icons/notifications-thick-muted2.i.svg').default],
  ['notifications-thick', require('assets/icons/notifications-thick.i.svg').default],
  ['notifications', require('assets/icons/notifications.i.svg').default],
  ['ocr', require('assets/icons/ocr.i.svg').default],
  ['online', require('assets/icons/online.i.svg').default],
  ['opportunities', require('assets/icons/opportunities.i.svg').default],
  ['override-deadline', require('assets/icons/override-deadline.i.svg').default],
  ['payout', require('assets/icons/payout.i.svg').default],
  ['pending-approval', require('assets/icons/pending-approval.i.svg').default],
  ['pending', require('assets/icons/pending.i.svg').default],
  ['phone', require('assets/icons/phone.i.svg').default],
  ['play', require('assets/icons/play.i.svg').default],
  ['profile', require('assets/icons/profile.i.svg').default],
  ['progress', require('assets/icons/progress.i.svg').default],
  ['provider-cut', require('assets/icons/provider-cut.i.svg').default],
  ['radio-blank', require('assets/icons/radio-blank.i.svg').default],
  ['radio-checked', require('assets/icons/radio-checked.i.svg').default],
  ['radio-error', require('assets/icons/radio-error.i.svg').default],
  ['radio-invert', require('assets/icons/radio-invert.i.svg').default],
  ['radio-selected', require('assets/icons/radio-selected.i.svg').default],
  ['radio-unchecked', require('assets/icons/radio-unchecked.i.svg').default],
  ['radio', require('assets/icons/radio.i.svg').default],
  ['ranking-calendar', require('assets/icons/ranking-calendar.i.svg').default],
  ['ranking-money', require('assets/icons/ranking-money.i.svg').default],
  ['ratings-thumbs-down', require('assets/icons/ratings-thumbs-down.i.svg').default],
  ['ratings-thumbs-up', require('assets/icons/ratings-thumbs-up.i.svg').default],
  ['ratings', require('assets/icons/ratings.i.svg').default],
  ['remove', require('assets/icons/remove.i.svg').default],
  ['rename-job', require('assets/icons/rename-job.i.svg').default],
  ['reputation', require('assets/icons/reputation.i.svg').default],
  ['restore', require('assets/icons/restore.i.svg').default],
  ['roles', require('assets/icons/roles.i.svg').default],
  ['search', require('assets/icons/search.i.svg').default],
  ['settings-nav', require('assets/icons/settings-nav.i.svg').default],
  ['settings', require('assets/icons/settings.i.svg').default],
  ['skills', require('assets/icons/skills.i.svg').default],
  ['sorting-two-arrows', require('assets/icons/sorting-two-arrows.i.svg').default],
  ['sorting', require('assets/icons/sorting.i.svg').default],
  ['star', require('assets/icons/star.i.svg').default],
  ['star2', require('assets/icons/star2.i.svg').default],
  ['stars', require('assets/icons/stars.i.svg').default],
  ['status-accepted', require('assets/icons/status-accepted.i.svg').default],
  ['status-pending', require('assets/icons/status-pending.i.svg').default],
  ['status-rejected', require('assets/icons/status-rejected.i.svg').default],
  ['stripe-logo', require('assets/icons/stripe-logo.i.svg').default],
  ['subtract', require('assets/icons/subtract.i.svg').default],
  ['switch-workspaces', require('assets/icons/switch-workspaces.i.svg').default],
  ['task-updates', require('assets/icons/task-updates.i.svg').default],
  ['teams', require('assets/icons/teams.i.svg').default],
  ['tick', require('assets/icons/tick.i.svg').default],
  ['total-paid', require('assets/icons/total-paid.i.svg').default],
  ['transaction-source', require('assets/icons/transaction-source.i.svg').default],
  ['transfer', require('assets/icons/transfer.i.svg').default],
  ['trophy', require('assets/icons/trophy.i.svg').default],
  ['unlock', require('assets/icons/unlock.i.svg').default],
  ['upload', require('assets/icons/upload.i.svg').default],
  ['users', require('assets/icons/users.i.svg').default],
  ['view', require('assets/icons/view.i.svg').default],
  ['virus', require('assets/icons/virus.i.svg').default],
  ['visa', require('assets/icons/visa.i.svg').default],
  ['workspace-name', require('assets/icons/workspace-name.i.svg').default]
])

export type IconName =
  | 'add-people'
  | 'add'
  | 'alert-avatar'
  | 'alert-blue'
  | 'alert'
  | 'amex'
  | 'analytics'
  | 'arrow-hover'
  | 'arrow'
  | 'back'
  | 'benefits'
  | 'call-end-call'
  | 'call-fullscreen-off'
  | 'call-fullscreen-on'
  | 'call-mic-off'
  | 'call-mic-on'
  | 'call-return'
  | 'call-screenshare-off'
  | 'call-screenshare-on'
  | 'call-speakers'
  | 'call-video-off'
  | 'call-video-on'
  | 'camera-off'
  | 'camera'
  | 'card'
  | 'change-start-date'
  | 'chart-arrow-up'
  | 'chat-attachment'
  | 'chat-bold'
  | 'chat-channels'
  | 'chat-code'
  | 'chat-cursive'
  | 'chat-delete'
  | 'chat-edit'
  | 'chat-emoji'
  | 'chat-formatting'
  | 'chat-h1'
  | 'chat-h2'
  | 'chat-image'
  | 'chat-link'
  | 'chat-list-bullet'
  | 'chat-list-ordered'
  | 'chat-mention'
  | 'chat-note'
  | 'chat-plus'
  | 'chat-prompt'
  | 'chat-reaction'
  | 'chat-strikethrough'
  | 'checkbox-blank'
  | 'checkbox-indeterminate'
  | 'checkbox-invert'
  | 'checkbox'
  | 'checkered-pattern'
  | 'checkmark'
  | 'circle'
  | 'clock'
  | 'close'
  | 'collaborators'
  | 'collect-payment'
  | 'colorpicker'
  | 'complete-job'
  | 'computer'
  | 'copy'
  | 'coupons'
  | 'dashboard'
  | 'date-claimed'
  | 'date-completed'
  | 'date-created'
  | 'date-deadline'
  | 'date-start'
  | 'date-submitted'
  | 'date-transacted'
  | 'date-transferred'
  | 'declined'
  | 'default-payment'
  | 'delete'
  | 'density-comfortable'
  | 'density-compact'
  | 'density-default'
  | 'discover'
  | 'documents'
  | 'download-pbfx'
  | 'download'
  | 'drag'
  | 'dropdown'
  | 'edit-outlined'
  | 'edit-roles'
  | 'edit-skills'
  | 'edit'
  | 'emojis'
  | 'filter'
  | 'flags'
  | 'forfeit-job'
  | 'gif'
  | 'googledrive'
  | 'hashtag'
  | 'heart'
  | 'hide'
  | 'hover-arrow-highlight'
  | 'hover-arrow'
  | 'hover-menu-highlight'
  | 'hover-menu'
  | 'info-blue'
  | 'info'
  | 'invoices'
  | 'job-updates'
  | 'jobs'
  | 'kanban-view'
  | 'legend-builder-breaker'
  | 'legend-builder-choice'
  | 'legend-builder-datetime'
  | 'legend-builder-document-upload'
  | 'legend-builder-effect'
  | 'legend-builder-milestones'
  | 'legend-builder-numeric'
  | 'legend-builder-path'
  | 'legend-builder-task'
  | 'legend-builder-text'
  | 'legend-builder-yes-no'
  | 'legends'
  | 'link'
  | 'list-view'
  | 'loader-arrows'
  | 'loader'
  | 'lock'
  | 'make-corrections'
  | 'mastercard'
  | 'menu'
  | 'message-bank'
  | 'mic'
  | 'more'
  | 'new-amendment'
  | 'notifications-thick-muted'
  | 'notifications-thick-muted2'
  | 'notifications-thick'
  | 'notifications'
  | 'ocr'
  | 'online'
  | 'opportunities'
  | 'override-deadline'
  | 'payout'
  | 'pending-approval'
  | 'pending'
  | 'phone'
  | 'play'
  | 'profile'
  | 'progress'
  | 'provider-cut'
  | 'radio-blank'
  | 'radio-checked'
  | 'radio-error'
  | 'radio-invert'
  | 'radio-selected'
  | 'radio-unchecked'
  | 'radio'
  | 'ranking-calendar'
  | 'ranking-money'
  | 'ratings-thumbs-down'
  | 'ratings-thumbs-up'
  | 'ratings'
  | 'remove'
  | 'rename-job'
  | 'reputation'
  | 'restore'
  | 'roles'
  | 'search'
  | 'settings-nav'
  | 'settings'
  | 'skills'
  | 'sorting-two-arrows'
  | 'sorting'
  | 'star'
  | 'star2'
  | 'stars'
  | 'status-accepted'
  | 'status-pending'
  | 'status-rejected'
  | 'stripe-logo'
  | 'subtract'
  | 'switch-workspaces'
  | 'task-updates'
  | 'teams'
  | 'tick'
  | 'total-paid'
  | 'transaction-source'
  | 'transfer'
  | 'trophy'
  | 'unlock'
  | 'upload'
  | 'users'
  | 'view'
  | 'virus'
  | 'visa'
  | 'workspace-name'
// Icon map end  (DO NOT EDIT)
